import axios from "axios";

function them(donVi){
  return axios.post(process.env.REACT_APP_URL_SERVER+"/cus/trungtam/them",donVi);
};
function getAll(){
  return axios.get(process.env.REACT_APP_URL_SERVER+"/cus/trungtam/getall");
};
function capNhat(donVi){
  return axios.post(process.env.REACT_APP_URL_SERVER+"/cus/trungtam/capnhat",donVi);
};
function xoa(ids){
  return axios.post(process.env.REACT_APP_URL_SERVER+"/cus/trungtam/xoa",ids);
};

const TrungTamService={
  them,
  getAll,
  capNhat,
  xoa

};
export default TrungTamService;
